<template>
	<section>
		<div class="row">
			<b-form-group class="col-md-3" label="Filtar por servicio:">
				<b-form-select placeholder="Todos" :options="optsRides" class="h-auto" v-model="filters.transportServiceId" ></b-form-select>
			</b-form-group>
			<b-form-group class="col-md-3" label=".">
				<b-button variant="outline-primary" @click="search">Buscar</b-button>
			</b-form-group>
		</div>
		<p class="text-danger text-sm" v-if="showAlertFilter"><small>Se esta filtrando por servicio</small></p>
		
		<AjaxTable
			stacked="lg"
			id="reservations-history-list"
			:filters="filtersClean"
			:columns="modelColumns"
			resource="reservations-history"
			responsive
			>
				<template #cell(change)="row">
					<span v-for="(change,i) in row.item.changes" :key="`${modelId}-${i}`">{{change}}<br/></span>
				</template>
				<template #cell(context)="row">
					<b-button size="sm" variant="info" @click="showContextModal(row.item.context)" class="ml-2">
						Ver
					</b-button>
				</template>
				
		</AjaxTable>

		<b-modal v-model="modalVisible" title="Contexto JSON" size="lg" ok-only>
			<pre class="json-container">{{ formattedContext }}</pre>
		</b-modal>
	</section>
</template>

<script>
import AjaxTable from '../../helpers/AjaxTable.vue'
import {mapState} from "vuex";
export default {
	props: {
		modelId: {
			type : Number,
			required: false,
			default:-1
		}
	},
	components: {  AjaxTable },
	data(){
		return {
			showAlertFilter:false,
			loading:false,
			modalVisible:false,
			currentContext:null,
			modelColumns : [
				{key:'context',label:'Contexto'},
				{key:'id',label:'ID del cambio'},
				{key:'creationDatetime',label:'Fecha'},
				{key:'user',label:'Usuario'},
				{key:'changeType',label:'Tipo de Cambio'},
				{key:'change',label:'Cambio'},
			],
			filters:{
				transportServiceId:""
			}
		}
	},
	methods:{
		nl2br(text){
			return text.replace(/\r\n/g, "<br/>")
		},
		search(){
			this.showAlertFilter = (this.filtersClean.transportServiceId>0)?true:false;
			this.$root.$emit('bv::refresh::table', 'reservations-history-list')
		},
		showContextModal(context){
			this.currentContext = context;
			this.modalVisible = true;
		}
	},
	computed:{
		...mapState("reservation", ["viewModel"]),
		filtersClean(){
			return {
				id:  this.modelId,
				transportServiceId:this.filters.transportServiceId
			}
		},
		optsRides(){
			let rides = [{value: "", text: 'Todos' }];
			this.viewModel.transportServices.forEach((ts)=>{
				if(ts.id>0){
					rides.push({value:ts.id,text:ts.serviceNumber})
				}
			})
			return rides;
		},
		formattedContext(){
			if(!this.currentContext) return '';
			try {
				const parsed = typeof this.currentContext === 'string'
					? JSON.parse(this.currentContext)
					: this.currentContext;
				return JSON.stringify(parsed, null, 2);
			} catch(e) {
				return this.currentContext;
			}
		}


	},
	mounted(){
		// this.$root.$emit('bv::refresh::table', 'reservations-history-list')
	},
	watch:{
		modelId: function(){
			// this.$root.$emit('bv::refresh::table', 'reservations-history-list')
		}
	}
}
</script>

<style >
	.json-container {
		background-color: #f5f5f5;
		padding: 15px;
		border-radius: 5px;
		overflow-x: auto;
		max-height: 500px;
		font-size: 12px;
		line-height: 1.4;
	}
</style>
